<!--
  E2 / F2 — the AI's suggested facility issues.

  The whole block is behind `items.length`: `suggestedRiskItems` is NULL for most requests and
  an empty suggestion list is a normal, silent outcome — not an empty state worth a message.
-->
<div class="risk-suggestion-list" *ngIf="items.length || showAddNew">

    <!-- Mirrors the TASK LIST heading row above it: title left, add-new right. The button is
         opt-in via `showAddNew` so a surface that has no manual-add path does not grow one. -->
    <div class="field-row">
        <h3>{{ heading }}</h3>
        <button mat-raised-button color="primary" type="button" *ngIf="showAddNew" [disabled]="disabled"
            matTooltip="Add an issue to the risk register by hand" (click)="onAddNew($event)">
            <mat-icon>add</mat-icon> Add New Item
        </button>
    </div>

    <div class="icd-container">
    <mat-list class="full-width">
        <mat-list-item class="auto-height" *ngFor="let suggestion of items; trackBy: trackBySuggestion">
            <div class="icd-item">

                <div class="icd-details">
                    <p matLine class="icd-title">{{ suggestion.issue }}</p>
                    <p matLine class="icd-score">
                        <span class="risk-chip risk-category-chip">{{ categoryLabel(suggestion.category) }}</span>
                        <span class="risk-chip" [ngClass]="severityClass(suggestion.severity)">{{ severityLabel(suggestion.severity) }}</span>
                        <span class="risk-suggestion-score" *ngIf="suggestion.score !== undefined && suggestion.score !== null">
                            Confidence: {{ suggestion.score }}%
                        </span>
                    </p>
                </div>

                <div class="view-icon">
                    <!--
                      D8 — THE VERBATIM QUOTE IS STILL A CONTROL, it has just moved.

                      It used to sit inline under every row, which is why this list stood three
                      times taller than the TASK LIST beside it. It is now one hover away here AND
                      rendered in full, unmissably, in the confirm-before-add dialog
                      (`risk-item-add-dialog.component.html:14`) — which is the moment that
                      actually matters: the doctor sees the sentence they said BEFORE it can reach
                      a letterhead. R4 is satisfied at the point of decision rather than at the
                      point of scanning a list.

                      A suggestion with NO quote still says so rather than showing an empty
                      tooltip — the absence is itself worth knowing.
                    -->
                    <button mat-icon-button type="button"
                        [matTooltip]="suggestion.quote || 'No verbatim quote was captured for this suggestion.'">
                        <mat-icon>format_quote</mat-icon>
                    </button>
                    <button mat-icon-button type="button" *ngIf="suggestion.reason" [matTooltip]="suggestion.reason">
                        <mat-icon>info</mat-icon>
                    </button>
                    <!-- Once added, the button simply goes — the TASK LIST pattern
                         (`patient-ai-request-detail.component.html:895`, `*ngIf="canAddTask(...)"`).
                         No tick and no separate "already added" list: the absence of the control is
                         the state, and the register itself is where confirmed items live. -->
                    <button mat-icon-button type="button" color="primary" *ngIf="canAdd(suggestion)" [disabled]="disabled"
                        matTooltip="Review and add this issue to the risk register" (click)="onAdd($event, suggestion)">
                        <mat-icon>library_add</mat-icon>
                    </button>
                </div>

            </div>
        </mat-list-item>
    </mat-list>
    </div>

</div>
